const apiUrl = "https://gz1npx06yf.execute-api.us-east-1.amazonaws.com/dev";

export async function saveConfig(auth, payload) {
  const token = await auth.getToken();
  const response = await fetch(`${apiUrl}/config`, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      payload: payload,
    }),
  });
  return response.json().then((response) => {
    if (response.body?.errorMessage) {
      throw Error(response.body.errorMessage);
    }
    return response;
  });
}
export async function saveLayout(auth, payload) {
  const token = await auth.getToken();
  const response = await fetch(`${apiUrl}/layout`, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      payload: payload,
    }),
  });
  return response.json().then((response) => {
    if (response.body?.errorMessage) {
      throw Error(response.body.errorMessage);
    }
    return response;
  });
}

export async function saveDocToS3(auth, payload) {
  const token = await auth.getToken();
  const response = await fetch(`${apiUrl}/audit`, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  return response.json().then((response) => {
    if (response.body?.errorMessage) {
      throw Error(response.body.errorMessage);
    }
    return response;
  });
}

export const getLayout = async (auth, id) => {
  const token = await auth.getToken();
  const model = await fetch(`${apiUrl}/layout?id=${id}`, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      const body = data.body;
      return body;
    })
    .catch((err) => {
      console.log(err.message);
    });
  return model;
};

export const getConfigs = async (auth, id) => {
  const token = await auth.getToken();
  const model = await fetch(`${apiUrl}/config?id=${id}`, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      const body = data.body;
      return body;
    })
    .catch((err) => {
      console.log(err.message);
    });
  return model;
};

export const getConfigList = async (auth, id) => {
  const token = await auth.getToken();
  const model = await fetch(`${apiUrl}/config/list?id=${id}`, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      const body = data.body;
      return body;
    })
    .catch((err) => {
      console.log(err.message);
    });
  return model;
};

export const getLayoutList = async (auth, id) => {
  const token = await auth.getToken();
  const model = await fetch(`${apiUrl}/layout/list?id=${id}`, {
    method: "GET",
    headers: {
      Authorization: token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      const body = data.body;
      return body;
    })
    .catch((err) => {
      console.log(err.message);
    });
  return model;
};

export const getScreenshot = async (auth, filepath, type) => {
  const signedUrl = await getFileDownloadUrl(auth, filepath);

  console.log("signedUrl", signedUrl, "filepath", filepath);

  const response = await fetch(signedUrl, {
    method: "GET",
  });

  return response.blob().then((response) => {
    const blob = response.slice(0, response.size, type);
    const imageUrl = URL.createObjectURL(blob);
    return imageUrl;
  });
};

export async function getFileDownloadUrl(auth, filepath) {
  try {
    const token = await auth.getToken();
    const downloadUrl = await fetchDownloadUrl(token, filepath);
    return downloadUrl.body;
  } catch (error) {
    console.error("Could not get file URL", error);
    throw error;
  }
}

async function fetchDownloadUrl(token, filename) {
  const response = await fetch(`${apiUrl}/screenshot`, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      file: filename,
    }),
  });
  return response.json().then((response) => {
    if (response.body?.errorMessage) {
      throw Error(response.body.errorMessage);
    }
    return response;
  });
}
